const locale = {
  excluirAlert: {
    titulo: 'Você realmente deseja excluir?',
  },
  cancelarAlert: {
    titulo: 'Existem alterações que não foram salvas.',
    mensagem: 'Tem certeza que deseja sair sem salvar?',
  },
  acoes: {
    confirmar: 'Sim',
    cancelar: 'Não',
  },
};

export default locale;
